export const downloadAppStyle = {
  button: {
    position: 'relative',
    width: 133,
    height: 45,
    cursor: 'pointer'
  }
}
